import type { EnvironmentId } from "@afar-research/contracts";
import { useRouter } from "@tanstack/react-router";
import { useCallback } from "react";

import { stackedThreadToast, toastManager } from "../components/ui/toast";
import { useUpdateClientSettings } from "./useSettings";

const PROVIDER_SETUP_DESCRIPTION =
  "Enable and prepare a Provider Instance for new threads and projects.";

/**
 * Select one Environment and open its existing Provider Settings setup surface.
 *
 * A Cloud Workspace has no such surface, so callers do not offer this there.
 */
export function useOpenProviderSettingsForEnvironment() {
  const router = useRouter();
  const updateClientSettings = useUpdateClientSettings();

  return useCallback(
    (environmentId: EnvironmentId): Promise<void> => {
      updateClientSettings({ environmentSettingsSelectionId: environmentId });
      toastManager.add(
        stackedThreadToast({
          type: "warning",
          title: "Provider setup required",
          description: PROVIDER_SETUP_DESCRIPTION,
        }),
      );
      return router.navigate({ to: "/settings/providers" }).then(() => undefined);
    },
    [router, updateClientSettings],
  );
}
